import { Box, Stack } from "@mui/system"

import { NewsCardTab } from "../components/NewsCardTab"
import { useAppLocalization } from "../../localization/components/AppLocalizationProvider"
import { RoadmapCardTab } from "../components/RoadmapCardTab"
import { StandardTabs } from "../../../shared/components/tabs/StandardTabs"
import NewFeatures from "../components/NewFeatures"
import { UserType } from "../../login/loginTypes"
import { useAppSelector } from "../../store/storeHooks"
import { selectUserType } from "../../login/loginSelectors"
import { Page } from "../../../shared/components/pageHeader/PageHeaderApi"
import { LocalizedStrict } from "../../localization/components/AppLocalized"
import { PageHeader } from "../../../shared/components/pageHeader/PageHeader"
import { Breadcrumb, BreadcrumbLink, StandardBreadcrumbs } from "../../../shared/components/links/StandardBreadcrumbs"
import { MERCHANT_ROUTE } from "../../../constants/routes"

export const NewsPage = () => {
    const { l10n } = useAppLocalization()
    const actualUserType = useAppSelector(selectUserType)
    const isUser = actualUserType === UserType.USER
    const isMerchant = actualUserType === UserType.MERCHANT

    const tabs = [
        {
            label: l10n.getString("news-gopay"),
            component: <NewsCardTab />,
        },
    ]
    if (isUser) {
        tabs.push({
            label: l10n.getString("news-new-features"),
            component: <NewFeatures />,
        })
    } else {
        tabs.push({
            label: l10n.getString("news-roadmap"),
            component: <RoadmapCardTab />,
        })
    }

    return (
        <>
            {/* for now we add only for merchant */}
            {isMerchant && (
                <LocalizedStrict id="user-home-top-bar-news-title" attrs={{ title: true }}>
                    <PageHeader page={Page.USER_NEWS} title="About Facilitynet">
                        <StandardBreadcrumbs>
                            <LocalizedStrict id="merchant-nav-item-home">
                                <BreadcrumbLink to={MERCHANT_ROUTE}>Home</BreadcrumbLink>
                            </LocalizedStrict>
                            <LocalizedStrict id="user-home-top-bar-news-title">
                                <Breadcrumb>About Facilitynet</Breadcrumb>
                            </LocalizedStrict>
                        </StandardBreadcrumbs>
                    </PageHeader>
                </LocalizedStrict>
            )}
            <Box sx={{ width: "100%", pt: "1rem" }}>
                <Stack position="relative">
                    <StandardTabs tabs={tabs} />
                </Stack>
            </Box>
        </>
    )
}
